module.exports = __webpack_public_path__ + "img/Causa_Krono.5024b736.png";